import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { modulo10, modulo116, modulo119 } from './modulos';
/**
 * Confirm password validator
 *
 * @param {AbstractControl} control
 * @returns {ValidationErrors | null}
 */
export function confirmPasswordValidator(
  field1 = 'password',
  field2 = 'passwordConfirm',
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent || !control) {
      return null;
    }

    const password = control.parent.get(field1);
    const passwordConfirm = control.parent.get(field2);

    if (!password || !passwordConfirm) {
      return null;
    }

    if (passwordConfirm.value === '') {
      return null;
    }

    if (password.value === passwordConfirm.value) {
      return null;
    }

    return { passwordsNotMatching: true };
  };
}

export const cedulaValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.parent || !control || !control.value) {
    return null;
  }

  const cedula = control.value;
  if (cedula.length !== 10) {
    return null;
  }

  const val = cedula.substring(0, 2);

  if (val < 0 || val > 24) {
    return { cedulaNoValida: true };
  }

  const tercerDigito = cedula.substring(2, 3);
  if (tercerDigito < 0 || tercerDigito > 5) {
    return { cedulaNoValida: true };
  }

  if (cedula.length >= 9) {
    const digitoVerificador = +cedula.substring(cedula.length - 1);
    const mod = modulo10(cedula.substring(0, 9));
    if (mod !== digitoVerificador) {
      return { cedulaNoValida: true };
    }
  }

  const numerosRepetidos = cedula;
  const numero = cedula.substring(0, 1);
  if (numerosRepetidos.split(numero).length === 11) {
    return { cedulaNoValida: true };
  }

  return null;
};

export const rucValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.parent || !control || !control.value) {
    return null;
  }

  const ruc = control.value;
  if (ruc.length !== 13) {
    return null;
  }

  const val = ruc.substring(0, 2);

  if (val < 0 || val > 24) {
    return { rucNoValido: true };
  }

  const tercerDigito = ruc.substring(2, 3);
  if (tercerDigito !== 9 && tercerDigito !== 6) {
    if (tercerDigito >= 0 && tercerDigito <= 5) {
      let cedula = ruc.slice(0, 10);
      const val = cedula.substring(0, 2);
      if (val < 0 || val > 24) {
        return { cedulaNoValida: true };
      }

      const tercerDigito2 = cedula.substring(2, 3);
      if (tercerDigito2 < 0 || tercerDigito2 > 5) {
        return { cedulaNoValida: true };
      }

      if (cedula.length >= 9) {
        const digitoVerificador2 = +cedula.substring(cedula.length - 1);
        const mod = modulo10(cedula.substring(0, 9));
        if (mod !== digitoVerificador2) {
          return { cedulaNoValida: true };
        }
      }

      let numerosRepetidos = cedula;
      let numero = cedula.substring(0, 1);
      if (numerosRepetidos.split(numero).length === 11) {
        return { cedulaNoValida: true };
      }

      return null;
    } else {
      return { rucNoValido: true };
    }
  }

  if (ruc.length === 10) {
    return cedulaValidator(control);
  }

  if (tercerDigito === 9) {
    const digitoVerificador = +ruc.substring(ruc.length - 4);
    const mod = modulo119(ruc.substring(0, 9));
    if (mod !== digitoVerificador) {
      return { rucNoValido: true };
    }
  }

  if (tercerDigito === 6) {
    const digitoVerificador = +ruc.substring(ruc.length - 4);
    const mod = modulo116(ruc.substring(0, 8));
    if (mod !== digitoVerificador) {
      return { rucNoValido: true };
    }
  }

  return null;
};

export const sinValorValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.parent || !control || !control.value) {
    return null;
  }

  const valor = control.value;

  if (valor === 'SIN_VALOR') {
    return { required: true };
  }

  return null;
};

export function lessThanNoCero(val: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent || !control || !control.value) {
      return null;
    }

    const valor = control.value;

    if (valor <= 0) {
      return null;
    }

    if (valor <= val) {
      return { lessThanNoCero: true };
    }

    return null;
  };
}

export const invalidIP: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.parent || !control || !control.value) {
    return null;
  }

  const ip = control.value;

  let regex: RegExp = new RegExp(
    '^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
  );

  if (!regex.test(ip)) {
    return { invalidIP: true };
  }

  return null;
};
